import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { adminUpdateUserApi, checkIsValidEmail, checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";

import AlertModal from 'web/components/AlertModal';

function TaxId(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [saveDisableState, setSaveDisableState] = useState(true)
    const [accordionOpen, setAccordionOpen] = useState(false)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    let pageFieldValues = pageProps.formikProps.values

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        if (!pageProps.formikProps.errors.businessURL && (fieldValues.taxId?.trim() === '' || (fieldValues.taxId?.trim().length === 9 && parseInt(fieldValues.taxId?.trim()) > 0))) setSaveDisableState(false)
        else setSaveDisableState(true)
    }, [pageProps.formikProps])

    const updateApiFunction = async () => {
        let id = pageProps.pageData.id
        let url = `ptms/internal/tax_id_update/${id}`
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            taxId: fieldValues.taxId,
            businessUrl: fieldValues.businessURL,
            businessDescription: fieldValues.businessDescription
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminUpdateUserApi(url, data, token))
        if (response.success) {
            setAlertModalContent('Detail has been updated successfully.')
            setAlertModal(!alertModal)
        } else {
            if (response.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const resetFieldsFunction = () => {
        const initailData = pageProps.pageData
        pageProps.setFieldValue('taxId', initailData.businessInfo?.taxId ? initailData.businessInfo?.taxId : '')
        pageProps.setFieldValue('businessURL', initailData.businessInfo?.businessUrl)
        pageProps.setFieldValue('businessDescription', initailData.businessInfo?.businessDescription)
    }

    return (
        <>
            <Container>
                <AccordionHeader>
                    <h6 onClick={() => {
                        if(accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Tax ID</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader>
                {accordionOpen &&
                    <AccordionBody>
                        <InputFieldsWrapper>
                            <div className="row">
                                <div className="col-md-6 fixed-height">
                                    {pageFieldValues.taxId !== '' && <h6>Tax Id</h6>}
                                    <div className='height-adjust'><NumberInput name='taxId' placeholder={`Tax Id`} maxLength={9} /></div>
                                </div>
                                <div className="col-md-6 fixed-height">
                                    {pageFieldValues.businessURL !== '' && <h6>Business Website URL</h6>}
                                    <div className='height-adjust'><TextInput name='businessURL' placeholder={`Business Website URL`} maxLength={200} /></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 fixed-height">
                                    {pageFieldValues.businessDescription !== '' && <h6>Business Description</h6>}
                                    <div className='height-adjust'><TextInput name='businessDescription' placeholder={`Business Description`} maxLength={200} /></div>
                                </div>
                            </div>
                        </InputFieldsWrapper>
                        <div className='view-edit-button-section'>
                            <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div>
                    </AccordionBody>
                }
            </Container>
            
            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )
}

export default TaxId